/* Slider with image and text */
import 'slick-carousel';

export function slider_with_image_and_text() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--slider-with-image-and-text--slides' ).length <= 0 ) {
				return;
			}

			$( '.block--slider-with-image-and-text' ).each( ( i, e ) => {
				const wrapper = $( e );
				const slider = wrapper.find( '.block--slider-with-image-and-text--slides' );
				const prevButton = wrapper.find('.custom-slick-navigation.prev');
				const nextButton = wrapper.find('.custom-slick-navigation.next');
				
				slider.slick( {
					arrows: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: false,
					prevArrow: prevButton,
					nextArrow: nextButton,
					fade: true,
					rows: 0,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								draggable: true,
								fade: true,
								adaptiveHeight: true,
							}
						}
					]
				} );
				
				slider.on('afterChange', function(event, slick, currentSlide){
					wrapper.find('.current-slide').text(currentSlide + 1);
				});

				const totalSlides = slider.slick('getSlick').slideCount;
				wrapper.find('.total-slides').text(totalSlides);
			});
		}

		init();

	} )( window.jQuery );
}
